import isArray from 'lodash/isArray'

// eslint-disable-next-line import/prefer-default-export
export const return2ndArgAsArray = ( state, arg ) => ( isArray( arg ) ? arg : [arg] )
